export const colorPalette = [
  '#fed057',
  '#ffd8d0',
  '#fd9498',
  '#c5baff',
  '#6e78e8',
  '#4a56e2',
  '#81e1ff',
  '#24cca7',
  '#00ad84',
  '#cc2424',
];
